import * as React from "react";
import { useMappedState } from "redux-react-hook";

import {
  S3Image,
  S3ImageProps
} from "src/core/shared/components/S3";

import { IStore } from "../store";

const BrandedImage: React.ReactFCWithChildren<S3ImageProps> = props => {
  const { theme } = useMappedState(({ global }: IStore) => ({ theme: global.settings && global.settings.theme }));

  return (
    <S3Image
      {...props}
      s3Key={props.s3Key || (theme ? theme.customDarkLogo : undefined)}
    />
  );
};

export default BrandedImage;
